import { useQuery } from '@tanstack/react-query';
import { getProviderActivationEvents } from '@uplift/api';

import { providerQueryKeys } from './providerQueryKeys';

export const useProviderActivationEvents = (providerId: string) => {
  return useQuery({
    queryKey: providerQueryKeys.activationEvents(providerId),
    queryFn: async () => {
      const events = await getProviderActivationEvents(providerId);

      return events.data;
    }
  });
};
